export default __webpack_public_path__ + "static/media/black-check-icon.46c6a920.svg";